import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { MoreVert } from '@mui/icons-material';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
// import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Tooltip } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import MarkAsReadIcon from 'app/components/Svgs/MarkAsReadIcon';
import MarkAsUnreadIcon from 'app/components/Svgs/MarkAsUnreadIcon';
import { StyledMenu } from './style';
import { Colors, ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';

export default function CustomizedMenus({
  // id,
  // handleDelete,
  // handleStatus,
  // title1,
  // title2,
  filterMessagesText,
  title3,
  title4,
  fetchUnreadMessages,
  setSelected,

  // user,
  flag,
  // handleUpdateMessages,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { darkmode } = useSelector(state => state.dark);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {flag === 'messages' ? (
        <Tooltip title={filterMessagesText}>
          <IconButton
            id='demo-customized-button'
            aria-controls={open ? 'demo-customized-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={{
              ...Buttons.baseStyle.iconButton,
              color: ColorsV2.white,
            }}
          >
            <TuneOutlinedIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton
          id='demo-customized-button'
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <MoreVert sx={darkmode && { color: Colors.primary }} />
        </IconButton>
      )}
      <StyledMenu
        id='demo-customized-menu'
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '10px',
            marginTop: '8px',
            minWidth: 180,
            backgroundColor: ColorsV2.secondary,
            color: 'white',
            border: `2px solid ${ColorsV2.white}`,
            boxShadow:
              'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {
              padding: '4px 0',
            },
            '& .MuiMenuItem-root': {
              margin: '0px 5px',
              borderRadius: '8px',
              '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: 'black',
                marginRight: '12px',
              },
              '&:hover': {
                backgroundColor: ColorsV2.acent,
                color: ColorsV2.white,
              },
            },
          },
        }}
      >
        {/* <MenuItem
          onClick={
            flag === 'actions'
              ? () => {
                  {
                    user ? handleStatus(id) : handleStatus(id.id, id.read, handleClose);
                  }
                }
              : () => {
                  handleUpdateMessages(true);
                  handleClose();
                }
          }
          disableRipple
        >
          <EditIcon />
          {title1}
        </MenuItem>
        <MenuItem
          onClick={
            flag === 'actions'
              ? () => {
                  handleDelete(id.id);
                }
              : () => {
                  handleUpdateMessages(false);
                  handleClose();
                }
          }
          disableRipple
        >
          {flag === 'actions' ? <Delete /> : <EditIcon />}
          {title2}
        </MenuItem> */}
        {flag === 'messages' && (
          <MenuItem
            onClick={() => {
              fetchUnreadMessages(true);
              handleClose();
              setSelected([]);
            }}
            sx={{ gap: '5px', fontSize: '0.7em', fontWeight: 'light' }}
          >
            <MarkAsUnreadIcon fill='white' fontSize='1em' />
            {title3}
          </MenuItem>
        )}
        {flag === 'messages' && (
          <MenuItem
            onClick={() => {
              fetchUnreadMessages(false);
              handleClose();
              setSelected([]);
            }}
            sx={{ fontSize: '0.7em', fontWeight: 'light' }}
          >
            <MarkAsReadIcon fill='white' fontSize='1.5em' />
            {title4}
          </MenuItem>
        )}
      </StyledMenu>
    </div>
  );
}
